import { useState } from "react";
import { ChevronRight, LayoutDashboard, PhoneCall } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import StatusCards from "./StatusCards";
import FormularioChamado from "./FormularioChamado";
import TabelaChamados from "./tabela/TabelaChamados";
import Rodape from "../rodape/Rodape"; // 🔗 importa rodapé

export default function Chamados() {
  const [modoFormulario, setModoFormulario] = useState(false);
  const [statusCounts, setStatusCounts] = useState({});
  const [filtroStatus, setFiltroStatus] = useState("");

  const handleNovo = () => {
    setModoFormulario(true);
  };

  return (
    <div className="h-full w-full relative overflow-hidden flex flex-col">
      <AnimatePresence mode="wait">
        {!modoFormulario ? (
          // ===== Tela Principal =====
          <motion.div
            key="principal"
            initial={{ x: 0, opacity: 1 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "-100%", opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="flex-1 w-full h-full p-6 pt-4 flex flex-col"
          >
            {/* 🔗 Breadcrumb */}
            <nav
              className="flex items-center space-x-3 text-sm mb-4"
              aria-label="Breadcrumb"
            >
              <LayoutDashboard size={16} className="text-slate-600" />
              <span className="cursor-pointer font-medium text-slate-700 hover:underline">
                Painel de Chamados
              </span>
              <ChevronRight size={12} className="text-slate-500" />
              <span className="text-slate-700 font-medium">Chamados</span>
            </nav>

            {/* 📦 Quadro principal */}
            <section className="bg-white rounded-md shadow-sm border border-[#4d4d4d] overflow-hidden flex-1 flex flex-col">
              {/* 🔲 Faixa com cor personalizada */}
              <div className="w-full bg-[#2b2b2b] px-4 py-2 flex items-center">
                <button
                  onClick={handleNovo}
                  aria-label="Abrir novo chamado"
                  className="flex items-center gap-2 px-4 py-2 text-white font-medium rounded 
                            transition-transform duration-200 hover:scale-105 bg-[#f95000]"
                >
                  <PhoneCall size={18} />
                  <span className="hidden sm:inline">Novo Chamado</span>
                </button>
              </div>

              {/* 📊 Cards de Status */}
              <StatusCards
                statusCounts={statusCounts}
                onSelectStatus={(status) => setFiltroStatus(status)}
              />

              {/* 📋 Tabela de Chamados */}
              <motion.div
                key={filtroStatus}
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -15 }}
                transition={{ duration: 0.3 }}
                className="p-4 border-t border-slate-200 flex-1"
              >
                <TabelaChamados
                  onStatusCountsChange={setStatusCounts}
                  filtroStatus={filtroStatus}
                />
              </motion.div>
            </section>

            {/* 🔻 Rodapé sempre abaixo do quadro */}
            <div className="mt-4">
              <Rodape />
            </div>
          </motion.div>
        ) : (
          // ===== Tela Formulário =====
          <motion.div
            key="formulario"
            initial={{ x: "100%", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "100%", opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="w-full h-full p-6 flex flex-col"
          >
            <FormularioChamado
              onVoltar={() => setModoFormulario(false)}
              onSalvo={() => setModoFormulario(false)}
            />

            {/* 🔻 Rodapé também aparece no formulário */}
            <div className="mt-4">
              <Rodape />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
